import {observer} from 'mobx-react';
import React from 'react';

import {TrackerInitializer} from '@udemy/event-tracking';
import {Footer} from '@udemy/footer';
import {Header} from '@udemy/react-header';
import {Toaster} from '@udemy/react-messaging-components';

import {useRootStore} from 'src/contexts/root-store-context';

import {InstructorHeader} from '../header/instuctor-header.react-component';
import styles from './layout.module.less';

export const getLayout = (page: React.ReactElement) => {
    return <Layout>{page}</Layout>;
};

const Layout = observer(({children}: {children: React.ReactElement}) => {
    const rootStore = useRootStore();
    return (
        <>
            {/* TODO: remove SmartBar rendering from Header component, re-add it here */}
            {/* <SmartBar /> */}
            <div className={styles['container']}>
                {rootStore.headerData.isLoggedIn && rootStore.instructorHeaderData && (
                    <InstructorHeader
                        {...rootStore.instructorHeaderData}
                        {...rootStore.headerData}
                    />
                )}
                {!rootStore.headerData.isLoggedIn && <Header {...rootStore.headerData} />}

                <main className={styles['content']} id="main-content-anchor">
                    {children}
                </main>
                <Footer
                    clientProps={rootStore.footerData}
                    serverProps={rootStore.footerData}
                    useLangPrefixedUrls={true}
                />
                <Toaster />
            </div>
            <TrackerInitializer />
        </>
    );
});
